import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { isLocalhost } from '../utils/environment';
import chainConfig from '../config/chainConfig';

const ChainContext = createContext();

export const useChainContext = () => useContext(ChainContext);

// Resuelve la cadena a partir del subdominio (telos.chainscout.io → telos-mainnet)
const getChainFromSubdomain = () => {
  const subdomain = window.location.hostname.split('.')[0];
  const chain = Object.keys(chainConfig).find(id => chainConfig[id].subdomain === subdomain);
  if (!chain) {
    console.warn(`Subdominio desconocido: ${subdomain}. Usando 'telos-mainnet' por defecto.`);
    return 'telos-mainnet';
  }
  return chain;
};

export const ChainProvider = ({ children }) => {
  
  const getInitialChain = () => {
    if (isLocalhost()) {
      // En desarrollo, intentar obtener de localStorage o usar valor por defecto
      const savedChain = localStorage.getItem('selectedChain');
      return savedChain || 'telos-mainnet';
    }
    
    // En producción, usar el subdominio como antes
    return getChainFromSubdomain();
  };
  
  const [currentChain, setCurrentChain] = useState(getInitialChain());
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [ualLogoutFn, setUalLogoutFn] = useState(null);

  const login = useCallback((userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  }, []);

  const logout = useCallback(async () => {
    // First, logout from UAL if the function is registered
    if (ualLogoutFn) {
      try {
        await ualLogoutFn();
      } catch (error) {
        console.error('Error during UAL logout:', error);
      }
    }
    
    // Then clear the context state
    setUser(null);
    setIsAuthenticated(false);
  }, [ualLogoutFn]);

  const registerUALLogout = useCallback((logoutFunction) => {
    setUalLogoutFn(() => logoutFunction);
  }, []);

  useEffect(() => {
    if (!isLocalhost()) {
      // Solo en producción, actualizar según el subdominio
      setCurrentChain(getChainFromSubdomain());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.hostname]); 


  const changeChain = useCallback((newChain) => {
    // En desarrollo, guardar la selección en localStorage
    if (isLocalhost()) {
      localStorage.setItem('selectedChain', newChain);
    }
    
    setCurrentChain(newChain);
  }, []);

  return (
    <ChainContext.Provider value={{ 
      currentChain, 
      setCurrentChain: changeChain, 
      user, 
      isAuthenticated, 
      login, 
      logout,
      registerUALLogout
    }}>
      {children}
    </ChainContext.Provider>
  );
};
